// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1-ndP","imageUploader":"EGiftCard_imageUploader__3uiHz"};